/**
 * Sayings in English, Hindi and Kannada for the intents the meaning router (ADR 0042) got wrong most (remember, chat,
 * guide, find, askContact, helpOffer, editCard), in pairs across the edges it crossed: find taken for market, helpOffer
 * for moving, chat for moving or market, guide for editCard. Never copied from vectors/intents (word overlap under 0.6
 * with every case).
 */
export const EDGE_SAYINGS = {
    editCard: [
        "put Bellandur as my work area on the card",
        "raise my hourly charge to 250",
        "remove Telugu from my languages",
        "I don't do cleaning anymore take it off my profile",
        "कार्ड पर मेरा इलाका बेलंदूर लिख दो",
        "घंटे का चार्ज 250 कर दो",
        "मेरी भाषाओं में से तेलुगु हटा दो",
        "अब सफाई का काम नहीं करती प्रोफाइल से निकाल दो",
        "ಕಾರ್ಡ್ ಅಲ್ಲಿ ನನ್ನ ಏರಿಯಾ ಬೆಳ್ಳಂದೂರು ಅಂತ ಹಾಕಿ",
        "ಗಂಟೆಗೆ 250 ಅಂತ ನನ್ನ ಚಾರ್ಜ್ ಮಾಡಿ",
        "ನನ್ನ ಭಾಷೆಗಳಲ್ಲಿ ತೆಲುಗು ತೆಗೀರಿ",
        "ಇನ್ಮೇಲೆ ಕ್ಲೀನಿಂಗ್ ಮಾಡಲ್ಲ ಪ್ರೊಫೈಲ್ ಇಂದ ತೆಗೆದುಬಿಡಿ",
    ],
    helpOffer: [
        "people coming here from Bihar can call me, I'll help them settle",
        "I've lived in Bengaluru ten years, happy to show newcomers the ropes",
        "sign me up to help new workers find their way",
        "if anyone new comes to my area tell them to contact me",
        "जो लोग गाँव से नए आते हैं उनकी मदद करना चाहती हूँ",
        "दस साल से बैंगलोर में हूँ नए लोगों को सब समझा दूँगा",
        "नए आने वालों की मदद के लिए मेरा नाम डाल दो",
        "कोई नया आए तो मुझसे बात करवा देना",
        "ಹೊಸದಾಗಿ ಬೆಂಗಳೂರಿಗೆ ಬಂದವರಿಗೆ ನಾನು ಗೈಡ್ ಮಾಡ್ತೀನಿ",
        "ಹತ್ತು ವರ್ಷದಿಂದ ಇಲ್ಲೇ ಇದೀನಿ ಹೊಸಬರಿಗೆ ಎಲ್ಲಾ ಹೇಳ್ಕೊಡ್ತೀನಿ",
        "ಹೊಸ ಕೆಲಸಗಾರರಿಗೆ ಸಹಾಯ ಮಾಡೋ ಲಿಸ್ಟ್ ಗೆ ನನ್ನ ಹೆಸರು ಸೇರಿಸಿ",
        "ಯಾರಾದ್ರೂ ಹೊಸಬರು ಬಂದ್ರೆ ನನ್ನ ನಂಬರ್ ಕೊಡಿ",
    ],
    helpStop: [
        "too busy now, no more calls from new people please",
        "अब नए लोगों के फोन मत भेजो समय नहीं है",
        "ಇನ್ಮೇಲೆ ಹೊಸಬರ ಕಾಲ್ ಕಳಿಸ್ಬೇಡಿ ಟೈಮ್ ಇಲ್ಲ",
    ],
    moving: [
        "I'm the one leaving for Pune next week, got work there",
        "अगले हफ़्ते मैं खुद दिल्ली जा रहा हूँ काम के लिए",
        "ನಾನೇ ಮುಂದಿನ ವಾರ ಕೆಲಸಕ್ಕೆ ಹೈದರಾಬಾದ್ ಗೆ ಹೋಗ್ತಿದೀನಿ",
    ],
    market: [
        "is 8000 a fair salary for a full-time cook",
        "खाना बनाने वाली को आठ हज़ार देना ठीक है क्या",
        "ಅಡುಗೆಯವರಿಗೆ ತಿಂಗಳಿಗೆ ಎಂಟು ಸಾವಿರ ಕೊಟ್ರೆ ಸರಿನಾ",
    ],
    guide: [
        "where do I update the address on my voter ID now that I live here",
        "is Marathahalli ok to rent a room if my work is in Whitefield",
        "is there a government hospital close to Electronic City",
        "how do I move my gas connection to this city",
        "यहाँ आधार में पता कैसे बदलवाते हैं",
        "बैंगलोर में रहने के लिए कौन सा इलाका सस्ता पड़ेगा",
        "मेट्रो कार्ड कहाँ बनता है",
        "बच्चे का दाखिला यहाँ सरकारी स्कूल में कैसे होगा",
        "ಬೆಂಗಳೂರಲ್ಲಿ ಆಧಾರ್ ವಿಳಾಸ ಹೇಗೆ ಚೇಂಜ್ ಮಾಡಿಸೋದು",
        "ಇಲ್ಲಿ ಕಡಿಮೆ ಬಾಡಿಗೆಗೆ ಯಾವ ಏರಿಯಾದಲ್ಲಿ ಮನೆ ಸಿಗುತ್ತೆ",
        "ಮೆಟ್ರೋ ಕಾರ್ಡ್ ಎಲ್ಲಿ ಮಾಡಿಸ್ಬೇಕು",
        "ಮಕ್ಕಳಿಗೆ ಲಸಿಕೆ ಹಾಕಿಸೋಕೆ ಇಲ್ಲಿ ಎಲ್ಲಿಗೆ ಹೋಗ್ಬೇಕು",
    ],
    find: [
        "the geyser hasn't heated up since morning",
        "need a cook who can start Monday budget around 8000",
        "anyone free to deep clean a 2BHK this weekend",
        "looking for a part-time driver for school drops",
        "बाथरूम का फ्लश खराब हो गया है",
        "आठ हज़ार तक में खाना बनाने वाली मिल जाए तो भेजो",
        "दीवार में सीलन आ गई है कोई आके देख ले",
        "बच्चों को संभालने के लिए एक आया चाहिए",
        "ಗೀಸರ್ ಬೆಳಗ್ಗೆಯಿಂದ ಬಿಸಿ ಆಗ್ತಿಲ್ಲ",
        "ಎಂಟು ಸಾವಿರಕ್ಕೆ ಅಡುಗೆಯವರು ಸಿಕ್ಕಿದ್ರೆ ಕಳ್ಸಿ",
        "ಈ ಭಾನುವಾರ ಮನೆ ಡೀಪ್ ಕ್ಲೀನ್ ಮಾಡೋಕೆ ಯಾರಾದ್ರೂ ಬೇಕು",
        "ಮಕ್ಕಳನ್ನ ನೋಡ್ಕೊಳೋಕೆ ಒಬ್ರು ಬೇಕಿತ್ತು",
    ],
    remember: [
        "write this down the Reddy family wants lunch packed by 11",
        "keep in mind the gas booking is due on the 20th",
        "save a note: madam said no work on Ugadi",
        "dont forget the gate code at the Prestige block is 4471",
        "लिख के रखो गुप्ता जी का पेमेंट हर महीने की 10 तारीख को आता है",
        "ये बात याद रखना मंगलवार को मैं देर से जाऊँगी",
        "नोट बना लो तीसरी मंज़िल वाली मैडम खाने में लहसुन नहीं लेतीं",
        "भूलना मत कल गैस वाले को फोन करना है",
        "ಇದನ್ನ ಬರ್ಕೊಳ್ಳಿ ರೆಡ್ಡಿ ಅವರ ಮನೇಲಿ ಸೋಮವಾರ ಕೆಲಸ ಇಲ್ಲ",
        "ನೆನಪಿಟ್ಕೊಳ್ಳಿ ಹತ್ತನೇ ತಾರೀಕು ಬಾಡಿಗೆ ಕಟ್ಟಬೇಕು",
        "ನೋಟ್ ಮಾಡ್ಕೊಳ್ಳಿ ಮೂರನೇ ಫ್ಲೋರ್ ಆಂಟಿ ಈರುಳ್ಳಿ ತಿನ್ನಲ್ಲ",
        "ಮರೀಬೇಡಿ ನಾಳೆ ಸಿಲಿಂಡರ್ ಬುಕ್ ಮಾಡ್ಬೇಕು",
    ],
    askContact: [
        "check with Lakshmi whether she can cover my Saturday shift",
        "has Imran reached the site yet",
        "ask Geeta if she knows a cook looking for work",
        "what time does Anil finish today",
        "लक्ष्मी से पूछो शनिवार को मेरी जगह जा सकती है क्या",
        "इमरान आज काम पे आया था क्या",
        "गीता दीदी को कोई अच्छा प्लंबर पता है क्या पूछ लो",
        "अनिल आज कितने बजे फ्री होगा",
        "ಲಕ್ಷ್ಮಿ ಹತ್ರ ಕೇಳಿ ಶನಿವಾರ ನನ್ ಬದಲು ಹೋಗ್ತಾರಾ ಅಂತ",
        "ಇಮ್ರಾನ್ ಸೈಟ್ ಗೆ ತಲುಪಿದ್ನಾ",
        "ಶೋಭಾ ಅವ್ರಿಗೆ ಒಳ್ಳೆ ಎಲೆಕ್ಟ್ರಿಷಿಯನ್ ಗೊತ್ತಾ ಕೇಳಿ",
        "ಪ್ರಕಾಶ್ ಇವತ್ತು ಎಷ್ಟೊತ್ತಿಗೆ ಫ್ರೀ ಆಗ್ತಾನೆ",
    ],
    schedule: [
        "keep 3 to 4 tomorrow blocked, I have a cleaning job at Mrs Das",
        "save Sunday 7 to 9 am for the Kapoor family",
        "रविवार सुबह 7 से 9 कपूर परिवार के यहाँ काम है, बुकिंग रख लो",
        "ರವಿವಾರ ಬೆಳಿಗ್ಗೆ 7 ರಿಂದ 9 ಕಪೂರ್ ಮನೆಯಲ್ಲಿ ಕೆಲಸ ಇದೆ, ಬುಕಿಂಗ್ ಇಡಿ",
    ],
    chat: [
        "my cousin just got a job in Pune, he leaves next week",
        "the maid next door told me she gets 6000 a month",
        "finally done with the painting job at the Iyer house",
        "came back from my village yesterday the train was packed",
        "मेरी बहन के पति दिल्ली में नौकरी के लिए चले गए",
        "पड़ोस वाली दीदी बोली उनको सात हज़ार मिलता है",
        "सुबह से बारिश हो रही है आज काम पर नहीं गई",
        "कल ही गाँव से लौटा हूँ",
        "ನಮ್ ತಮ್ಮ ಮುಂದಿನ ವಾರ ಕೆಲಸಕ್ಕೆ ಹೈದರಾಬಾದ್ ಗೆ ಹೋಗ್ತಾನೆ",
        "ಪಕ್ಕದ ಮನೆ ಅಡುಗೆಯವರು ತಿಂಗಳಿಗೆ ಎಂಟು ಸಾವಿರ ತಗೊಳ್ತಾರಂತೆ",
        "ಇವತ್ತು ಎರಡು ಮನೆ ಕ್ಲೀನಿಂಗ್ ಮುಗಿಸ್ದೆ",
        "ನಿನ್ನೆ ಊರಿಂದ ವಾಪಸ್ ಬಂದೆ ಬಸ್ ತುಂಬಾ ರಶ್ ಇತ್ತು",
    ],
};
//# sourceMappingURL=sayings-edges.js.map